import {
  Users,
  RefreshCcw,
  DollarSign,
  BarChart3,
  AlertTriangle,
  LayoutDashboard,
  PhoneCall,
  FileBarChart,
  UserCheck,
  Calendar,
  TrendingUp,
  Phone,
  Scale,
  Activity,
  Monitor,
} from "lucide-react";
function navigate(){

}
function handleUpdateUsers(){

}
const sections = [
  {
    title: "User & System Management",
    items: [
      {
        title: "Add Users",
        icon: <Users size={22} />,
        path: "/users",
      }
    ],
  },

  {
    title: "Cost & Finance",
    items: [
      {
        title: "Operation Cost Management",
        icon: <DollarSign size={22} />,
        path: "/operationscost",
      },
      {
        title: "Marketing Cost Management",
        icon: <BarChart3 size={22} />,
        path: "/marketingcost",
      },
      {
        title: "Loss Tracker",
        icon: <AlertTriangle size={22} />,
        path: "/chargeback",
      },
    ],
  },

  {
    title: "Analytics & Monitoring",
    items: [
      {
        title: "Analytics Dashboard",
        icon: <LayoutDashboard size={22} />,
        path: "/analytics-dashboard",
      },
      {
        title: "Call Analytics",
        icon: <PhoneCall size={22} />,
        path: "/call-logs",
      },
      {
        title: "Productivity Summary",
        icon: <FileBarChart size={22} />,
        path: "/marketing-expense-table",
      },
    ],
  },

  {
    title: "Agent Live Monitoring",
    items: [
      {
        title: "Agent Live Dashboard",
        icon: <Monitor size={22} />,
        path: "/agent-operations-dashboard",
      },
    ],
  },

  {
    title: "Reports",
    items: [
      {
        title: "Agent Performance Report",
        icon: <UserCheck size={22} />,
        path: "/agent-report",
      },
      {
        title: "Monthly MCO Report",
        icon: <Calendar size={22} />,
        path: "/reports/monthly-mco",
      },
      {
        title: "MC Report",
        icon: <TrendingUp size={22} />,
        path: "/queue-report",
      },
      {
        title: "Gateway Report",
        icon: <Phone size={22} />,
        path: "/gateway-report",
      },
      {
        title: "Chargeback Report",
        icon: <Scale size={22} />,
        path: "/chargeback-report",
      },
    ],
  },
];

// Glow color mappings
const glowColors = {
  cyan: {
    border: "from-cyan-400 to-blue-500",
    shadow: "shadow-cyan-400/50",
    bg: "bg-cyan-500/10",
  },
  rose: {
    border: "from-rose-400 to-red-500",
    shadow: "shadow-rose-400/50",
    bg: "bg-rose-500/10",
  },
  emerald: {
    border: "from-emerald-400 to-green-500",
    shadow: "shadow-emerald-400/50",
    bg: "bg-emerald-500/10",
  },
  blue: {
    border: "from-blue-400 to-cyan-500",
    shadow: "shadow-blue-400/50",
    bg: "bg-blue-500/10",
  },
};

export { sections, glowColors };